/**
 * @file   src\Pages\MySubscriptions.tsx
 * @brief  MySubscriptions page.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { React, Link, useState, useNavigate, useParams, useEffect,Modal, useLocation} from "../utils/thirdpartyComponents"
import { Badge, Button } from "react-bootstrap";
import Gobackicon from "../assets/images/left-arrow-small.svg";
import CWFooter from "src/components/CWFooter";
import "src/styles/inner-page-styles.scss";
import { pageURLs } from "src/utils/pageUrls";
import axios from "src/config/axiosConfig";
import { MessageToaster } from "src/utils/toastUtil";
import { PurchasedSubscription } from "src/interfaces/subscriptionInterface";
import SmallLoader from '../components/SmallLoader';
import {splitTotal, formatMinutesToMinutesSeconds, getFromLocalStorage} from "../utils/helper";
import { BayApi } from "src/utils/apiUrls";
import { SubscriptionandwashpriceApi} from "../utils/apiUrls";
import { ISubscriptionandsinglewash,  ISingleWasharray , ISubscriptionarray} from '../interfaces/generalInterface';
import { CommonMessages } from 'src/messages/validationMessages';
import moment from "moment";
import { ServiceType } from "src/utils/enums";

const SelfServeSelectWash = () => {
    const navigate = useNavigate();
    const params = useParams();
     // Instantiate MessageToaster
     const toaster = new MessageToaster();
     const location = useLocation();
     const queryParams = new URLSearchParams(location.search);
    // State to manage more and less button
    const [showAll, setShowAll] = useState(false);
    const [loading,setLoading] =  useState(false);
    const [showPaymentfailModal, setShowPaymentfailModal] = useState(false);
    const handleClosePaymentfailModal = () => setShowPaymentfailModal(false);
    const handleShowPaymentfailModal = () => setShowPaymentfailModal(true);
    const [singleWash, setSingleWash] = useState<ISingleWasharray[]>([]);
    const [purchasedsingleWash, setPurchasedSingleWash] = useState<PurchasedSubscription>();
    const [purchasedSubscription, setPurchasedSubscription] = useState<PurchasedSubscription[]>();
    const [showOrText,setShowOrText] =  useState(false);
    // const [showSingleWashOrText,setShowSingleWashOrText] =  useState(false);
    const [purchasedSubscriptionExist,setpurchasedSubscriptionExist] =  useState(0);
    const [purchasedSingleWashExist,setpurchasedSingleWashExist] =  useState(0);
    const [showSinleWashCancelConfirmation, setSinleWashCancelConfirmation] = useState<boolean>(false);
    const [purchsedFrom, setpurchsedFrom] = useState()
    const locationId_from_storage = localStorage.getItem('selectedLocation');
    const locationId = locationId_from_storage ? parseInt(locationId_from_storage, 10) : 0;
    const selectedBay = localStorage.getItem('selectedBay');
    const scanAction = (queryParams.get('scan') ==='true') ?  true  : false;
    const [disableProceedButton, setdisableProceedButton] = useState(false)
    const bayselectAction = (queryParams.get('bayselect') === 'true') ? true : false;
    const bayTypeId = queryParams.get('bayTypeId')

    // initial loading
    useEffect(() => {
        if(selectedBay === "" || selectedBay <= 0 || selectedBay === undefined || selectedBay === null) {
           navigate(`/${params.carwashname}`)
        } 
        washSelectionChecking()
      }, []);

    
    const toggleShowAll = () => {
        setShowAll(!showAll);
    };




    
    //Bay status checking
    const handleSubmit = async (userSubscriptionID:number,hasVacuumWash=0,hasSelfServeWash=0) => {
      // API call to get bay status
      try {

        setdisableProceedButton(true)
        setLoading(true); // Show loader

       
        
        const param = selectedBay;
        const geo_location  = getFromLocalStorage('geolocation');
        const timezoneOffset = (new Date()).getTimezoneOffset();
        if((geo_location?.lat && geo_location?.long) || scanAction)
        {
            if(hasVacuumWash==1 && Number(bayTypeId)== ServiceType.vacuumWash)
            {
            navigate(`/${params.carwashname}/${pageURLs.selfService}?scan=${scanAction}&freeVacuum=true`,{ state: { UserSubscriptionID: userSubscriptionID,bayId:selectedBay }});
            }
            else if(hasSelfServeWash==1 && Number(bayTypeId)== ServiceType.selfServe)
            {
            navigate(`/${params.carwashname}/${pageURLs.selfService}?scan=${scanAction}&freeSelfServe=true`,{ state: { UserSubscriptionID: userSubscriptionID,bayId:selectedBay }});
            }
            else{
            navigate(`/${params.carwashname}/${pageURLs.selfService}?scan=${scanAction}`,{ state: { UserSubscriptionID: userSubscriptionID,bayId:selectedBay }});
            }
            return false;
         
        }
        else{
          toaster.toastError(CommonMessages.no_loc_permission);
        }
      } catch (error: any) {
        throw new Error(error.response?.data?.message || error.message);
      }
    }


    //Check subscription status
    const washSelectionChecking = async() => {
      const geo_location  = getFromLocalStorage('geolocation')
      if((geo_location?.lat && geo_location?.long) || scanAction)
      {
        const timezoneOffset = (new Date()).getTimezoneOffset();
        setLoading(true); // Show loader
        const { data } = await axios.get(BayApi.CHECK_WASHES_AVAILABLE, {
          params: {
              lat: (!scanAction) ? geo_location?.lat : 0,
              lng: (!scanAction) ? geo_location?.long : 0,
              bayId : selectedBay,
              offset: timezoneOffset,
          }
        });
        setLoading(false); // Hide loader
        if(data.error === 0)
        {
           
            const subscriptions = [];
            const subscriptionData = data?.data?.subData;
            let activeSubscriptionExist = 0;
            let singleWashPurchased = 0; 
            let singleWashSubscriptionId = 0
            setpurchasedSingleWashExist(data?.data?.subStatus?.hasSingleWash)
            for(let i = 0; i< subscriptionData.length; i++) {
                if(subscriptionData[i].SubscriptionType === 1) {
                    setPurchasedSingleWash(subscriptionData[i]);
                    singleWashSubscriptionId = subscriptionData[i].SubscriptionId;
                    singleWashPurchased = 1;
                } else {
                    subscriptions.push(subscriptionData[i])
                    if(subscriptionData[i].WashTimeRemaining > 0) {
                        activeSubscriptionExist = 1;
                    }
                }
            }
            if(activeSubscriptionExist) {
                setpurchasedSubscriptionExist(1);
            }
            setPurchasedSubscription(subscriptions)
            if(singleWashPurchased === 1) {
                checkOrTextStatus(data.data.subStatus.hasSingleWash, activeSubscriptionExist, singleWash)
                
            } 
          
        } else {
          toaster.toastError(data.message);
          navigate("/"+params.carwashname+"/"+pageURLs.home)
        } 
        
      } else{
        toaster.toastError(CommonMessages.no_loc_permission);
        navigate("/"+params.carwashname+"/"+pageURLs.home)
      }
    }

    function showPrice(Price : number){
        const { dollars, cents } = Price? splitTotal(Price) : {dollars:"",cents:""}
        const centswith2Digit = (cents && cents.length < 2) ? cents+'0' : cents;
        return <><div className="cw-card-value">${dollars}
            <span className="decimal-sec">.{cents ? centswith2Digit : "00"}</span>
        </div></>
    }

    const checkOrTextStatus = async(hasSingleWash : number, hasSubscription : number, singleWashData : any) => {
        if(hasSingleWash === 1 && hasSubscription === 1) {
            setShowOrText(true);
        } else {
            setShowOrText(false)
        }
      
    }

    const cancelSingleWashCancellation = ()=>{
        setSinleWashCancelConfirmation(false)
    }

    const cancelSinglewashConfirm = ()=>{
        setSinleWashCancelConfirmation(true)
    }

    const cancelSingleWash = async()=>{
        try {
            setLoading(true); // Show loader
            const responseSingleWash = await axios.get(SubscriptionandwashpriceApi.CANCEL_SINGLE_WASH+'?bayId='+ selectedBay+'&bayType='+bayTypeId);
    
            if(responseSingleWash?.data?.error === 0)
            {
                setSinleWashCancelConfirmation(false)
                setpurchasedSingleWashExist(0)
                setPurchasedSingleWash({
                    UserSubscriptionID: 0, 
                    WashName: '',
                    noOfWashRemaining: 0,
                    isCancelled: false,           
                    endDate: '',                
                    startDate: '' ,               
                    Price: 0,                   
                    SubscriptionDetails: '',     
                    noOfWash: 0,        
                })
                setLoading(false); // Show loader
                setpurchasedSubscriptionExist(0)
                toaster.toastSuccess(responseSingleWash?.data?.message)
            }
            else
            {
                setLoading(false); // Show loader
                setSinleWashCancelConfirmation(false)
                toaster.toastError(responseSingleWash?.data?.message);
            }
            } catch (error: any) {
                setLoading(false); // Show loader
                setSinleWashCancelConfirmation(false)
                throw new Error(error.response?.data?.message || error.message);
            }
    }

    

    return (

        <div className="common-content-wrap pb-80">
            <div className="inner-content-wrap">
                <div className="common-header two-block-header">
                    <div className="pe-4 ps-4 pt-0 pb-0 h-100">
                        <div className="common-header-inner">
                            <Link to={"/" + params.carwashname+ "/" + pageURLs.home } className="back-link"><img src={Gobackicon} alt="Car Wash App" /></Link> Select {Number(bayTypeId)== ServiceType.vacuumWash ? "Use":"Wash"}
                        </div>
                    </div>
                </div>
                
                    <div className="main-content-wrap pe-0 ps-0 pt-0">

                        {(purchasedsingleWash && purchasedSingleWashExist ) ? <div  className="my-subscription-wrap">
                            <div className="title">
                                <h4>Active Single {Number(bayTypeId)== ServiceType.vacuumWash ? "Use":"Wash"}</h4>
                            </div>

                            


                            <div className="cw-card ">
                                
                                <div className="cw-card-content">
                                    <div className="cw-card-leftcontent">
                                        <h6>{purchasedsingleWash?.WashName}</h6>
                                    </div>
                                    <div className="cw-card-rightcontent">
                                    {showPrice(purchasedsingleWash?.Price)}
                                    </div>
                                </div>
                               
                                <div className="cw-card-btnwrap">
                                    <Button variant="primary" className="primary-btn" onClick={(e) => { handleSubmit(purchasedsingleWash?.UserSubscriptionID) }} disabled={disableProceedButton === true ? true : false}>Proceed</Button>
                                </div>
                                <div className="cw-card-btnwrap">
                                    <Button variant="primary" className="primary-btn" onClick={cancelSinglewashConfirm }>Cancel</Button>
                                </div>
                            </div>
                        </div> : '' }
                        {showOrText ? <div className="or text-center"><h6>OR</h6></div> : ''}
                        {purchasedSubscription?.length  ? <div  className="my-subscription-wrap">
                            <div className="title">
                                <h4>Active Subscription</h4>
                            </div>
                            {purchasedSubscription.map((mySubscriptions, index) => ( 
                                (mySubscriptions?.HasVacuumWash ==1 && Number(bayTypeId) == ServiceType.vacuumWash) || (mySubscriptions?.HasSelfService ==1 && Number(bayTypeId) == ServiceType.selfServe) ? <div className={mySubscriptions?.HasVacuumWash ==1 && mySubscriptions?.NoOfVacuumWashRemaining > 0 || mySubscriptions?.HasSelfService == 1 && mySubscriptions?.NumberOfSelfServicesRemaining && mySubscriptions?.NumberOfSelfServicesRemaining > 0   ? "cw-card" : "cw-card card-disable"}>
                                <div className="cw-card-content">
                                    <div className="cw-card-leftcontent">
                                        <h6>{mySubscriptions?.WashName}</h6>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: 
                                        showAll ? mySubscriptions?.SubscriptionDetails : (mySubscriptions?.SubscriptionDetails.length > 150 ? `${mySubscriptions?.SubscriptionDetails?.substring(0, 150)}...` : mySubscriptions?.SubscriptionDetails)}}
                                        ></div>

                                        {mySubscriptions?.SubscriptionDetails?.length > 150 && ( <>
                                            <div>
                                                <a onClick={toggleShowAll} className="more-less-btn">
                                                    {showAll ? <>
                                                        <span className="align-text-top">Less</span>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="8.148" height="10.365" viewBox="0 0 8.148 10.365"><g transform="translate(1.061 9.615) rotate(-90)"><g transform="translate(-7.003 -9.256)"><line x2="8.199" transform="translate(7.003 12.269)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /><path d="M13,8l3.014,3.014L13,14.027" transform="translate(-0.146 1.256)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /></g></g></svg>
                                                    </> : <><span className="align-text-top">More</span>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="8.148" height="10.365" viewBox="0 0 8.148 10.365"><g transform="translate(7.088 0.75) rotate(90)"><g transform="translate(-7.003 -9.256)"><line x2="8.199" transform="translate(7.003 12.269)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /><path d="M13,8l3.014,3.014L13,14.027" transform="translate(-0.146 1.256)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /></g></g></svg>
                                                    </>} 
                                                </a>
                                            </div>
                                        </> )}
                                    </div>
                                    <div className="cw-card-rightcontent">
                                    {showPrice(mySubscriptions?.Price)}
                                       
                                        <div className="cw-card-smalltext">Per Month</div>
                                    </div>
                                </div>
                                <div className="cw-card-validity d-grid">
                                    <div className="info-block text-center">
                                        <p>{Number(bayTypeId) == ServiceType.selfServe ? "Actual Free Self Serve Sessions" : "Actual Free Vacuum Sessions"} </p>
                                        <span>{Number(bayTypeId) == ServiceType.selfServe  ? mySubscriptions?.NumberOfSelfServices : mySubscriptions?.NoOfVacuumWash}</span>
                                    </div>
                                    <div className="info-block text-center">
                                       <p>{ Number(bayTypeId) == ServiceType.selfServe ? "Remaining Free Self Serve Sessions" : "Remaining Free Vacuum Sessions"} </p> 
                                        <span>{Number(bayTypeId) == ServiceType.selfServe ? mySubscriptions?.NumberOfSelfServicesRemaining : mySubscriptions?.NoOfVacuumWashRemaining}</span>
                                    </div>
                                     { mySubscriptions?.SubscriptionType !=3 ?
                                      <div className="info-block text-center">
                                       
                                        <div>
                                        <p>Valid Till</p>
                                        <span>{moment(new Date(mySubscriptions?.EndDate)).format("MM/DD/YYYY")}</span>
                                        </div> 
                                       
                                        {mySubscriptions?.isCancelled ? <Badge bg="danger">Canceled</Badge> : ""}
                                    </div>
                                    :""}
                                  
                                   
                                </div>
                                <div className="cw-card-btnwrap">
                                    {Number(bayTypeId) == ServiceType.selfServe ?
                                            <Button variant="primary" className="primary-btn" onClick={(e) => { handleSubmit(mySubscriptions?.UserSubscriptionID,0,1) }} disabled={((mySubscriptions?.NumberOfSelfServicesRemaining  ?? 0) <= 0 || disableProceedButton === true) ? true : false}>Proceed</Button>:
                                    <Button variant="primary" className="primary-btn" onClick={(e) => { handleSubmit(mySubscriptions?.UserSubscriptionID,1,0) }} disabled={(mySubscriptions?.NoOfVacuumWashRemaining <= 0 || disableProceedButton === true) ? true : false}>Proceed</Button>

                                    }
                                </div>
                            </div> :
                                <div className={mySubscriptions?.WashTimeRemaining > 0 ? "cw-card" : "cw-card card-disable"}>
                                <div className="cw-card-content">
                                    <div className="cw-card-leftcontent">
                                        <h6>{mySubscriptions?.WashName}</h6>
                                        
                                       <div
                                            dangerouslySetInnerHTML={{
                                                __html: showAll ? mySubscriptions?.SubscriptionDetails : (mySubscriptions?.SubscriptionDetails?.length > 150 ? `${mySubscriptions?.SubscriptionDetails?.substring(0, 150)}...` : mySubscriptions?.SubscriptionDetails)}}
                                                >
                                        </div>

                                        {mySubscriptions?.SubscriptionDetails?.length > 150 && ( <>
                                            <div>
                                                <a onClick={toggleShowAll} className="more-less-btn">
                                                    {showAll ? <>
                                                        <span className="align-text-top">Less</span>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="8.148" height="10.365" viewBox="0 0 8.148 10.365"><g transform="translate(1.061 9.615) rotate(-90)"><g transform="translate(-7.003 -9.256)"><line x2="8.199" transform="translate(7.003 12.269)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /><path d="M13,8l3.014,3.014L13,14.027" transform="translate(-0.146 1.256)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /></g></g></svg>
                                                    </> : <><span className="align-text-top">More</span>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="8.148" height="10.365" viewBox="0 0 8.148 10.365"><g transform="translate(7.088 0.75) rotate(90)"><g transform="translate(-7.003 -9.256)"><line x2="8.199" transform="translate(7.003 12.269)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /><path d="M13,8l3.014,3.014L13,14.027" transform="translate(-0.146 1.256)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /></g></g></svg>
                                                    </>} 
                                                </a>
                                            </div>
                                        </> )}
                                    </div>
                                    <div className="cw-card-rightcontent">
                                    {showPrice(mySubscriptions?.Price)}
                                       
                                       { mySubscriptions?.SubscriptionType !=3 ? <div className="cw-card-smalltext">Per Month</div> :""}
                                    </div>
                                </div>
                                <div className="cw-card-validity d-grid">
                                    <div className="info-block text-center">
                                        <p>Actual Minutes</p>
                                        <span>{mySubscriptions?.WashTime}</span>
                                    </div>
                                    <div className="info-block text-center">
                                        <p>Remaining Minutes</p>
                                        {mySubscriptions?.WashTimeRemaining > 0 ? <span>{formatMinutesToMinutesSeconds(mySubscriptions?.WashTimeRemaining)}</span> : <Badge bg="danger">No Time Remaining</Badge>}
                                    </div>
                                     { mySubscriptions?.SubscriptionType !=3 ?
                                    <div className="info-block text-center">
                                   
                                        <div>
                                        <p>Valid Till</p>
                                        <span>{moment(new Date(mySubscriptions?.EndDate)).format("MM/DD/YYYY")}</span>
                                        </div>
                                       
                                        {mySubscriptions?.isCancelled ? <Badge bg="danger">Canceled</Badge> : ""}
                                    </div>  :""}
                                   
                                </div>
                                <div className="cw-card-btnwrap">
                                    <Button variant="primary" className="primary-btn" onClick={(e) => { handleSubmit(mySubscriptions?.UserSubscriptionID) }} disabled={(mySubscriptions?.WashTimeRemaining <= 0 || disableProceedButton === true) ? true : false}>Proceed</Button>
                                </div>
                            </div>  )) }
                        </div> : ''}
                     
                    </div>
            </div>

            <Modal
                show={showSinleWashCancelConfirmation}
                onHide={cancelSingleWashCancellation}
                centered
                className='notification-modal'
            >
                <Modal.Body className='text-center'>
                <h6>Are you sure you want to cancel this single wash?</h6>
                </Modal.Body>
                <Modal.Footer className='d-grid'>
                <Button variant="light" className="m-0" onClick={cancelSingleWashCancellation}>No</Button>
                <Button variant="primary" className='primary-btn btn-main m-0' onClick={cancelSingleWash}>Yes</Button>
                </Modal.Footer>
            </Modal>


            {/* <Modal
                show={showSinleWashNewPurchaseConfirmation}
                onHide={SingleWashPurchaseCancellation}
                centered
                className='notification-modal'
            >
                <Modal.Body className='text-center'>
                <h6>You've already initiated a single wash. If you purchase this single wash, your previously selected single wash will be canceled. Do you want to continue?</h6>
                </Modal.Body>
                <Modal.Footer className='d-grid'>
                <Button variant="light" className="m-0" onClick={SingleWashPurchaseCancellation}>No</Button>
                <Button variant="primary" className='primary-btn btn-main m-0' onClick={confirmSignleWashPurchase}>Yes</Button>
                </Modal.Footer>
            </Modal> */}
            <CWFooter activeLink="Home"/>
            {loading && <SmallLoader />}

        </div>
    )
}

export default SelfServeSelectWash;
